import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import {
  LucideAngularModule,
  CarIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from 'lucide-angular';
import type {
  AplicacionVehiculo,
  GuiaProductoTreeElement,
} from '../../../types/product.types';

@Component({
  selector: 'allas-vehicle-guide-modal',
  imports: [CommonModule, DialogModule, LucideAngularModule],
  template: `
    <div>
      @if (vehicleGuideTree.length > 0) {
      <div class="mb-4">
        <p class="text-gray-600 text-sm mb-4 fs-condensed">
          Este producto es compatible con los siguientes vehículos:
        </p>
        <div class="columns-3 gap-1 space-y-1">
          @for (brand of vehicleGuideTree; track brand.marca) {
          <div class="break-inside-avoid space-y-2 mb-1">
            <!-- Marca -->
            <div
              class="flex items-center gap-2 py-2 cursor-pointer hover:bg-gray-50 rounded fs-condensed font-semibold"
              (click)="brand.expanded = !brand.expanded"
            >
              <lucide-icon
                [name]="brand.expanded ? chevronDownIcon : chevronRightIcon"
                class="w-4 h-4 text-appPrimary-500"
              />
              <span>{{ brand.marca }}</span>
            </div>

            <!-- Modelos (hidden por defecto) -->
            <div class="space-y-1" [class.hidden]="!brand.expanded">
              @for (model of brand.modelos; track model.modeloMotor) {
              <div class="ml-4">
                <!-- Modelo -->
                <div
                  class="flex items-center gap-2 py-1 cursor-pointer fs-condensed"
                  (click)="model.expanded = !model.expanded"
                >
                  <lucide-icon
                    [name]="model.expanded ? chevronDownIcon : chevronRightIcon"
                    class="w-4 h-4 text-appPrimary-500"
                  />
                  <span>{{ model.modeloMotor }}</span>
                </div>

                <!-- Años (hidden por defecto) -->
                <div class="space-y-1 ml-4" [class.hidden]="!model.expanded">
                  @for (year of model.rangos; track year) {
                  <div
                    class="flex items-center gap-2 py-1 rounded fs-condensed"
                  >
                    <lucide-icon
                      [name]="carIcon"
                      class="size-4 text-gray-500"
                    />
                    <span>{{ year }}</span>
                  </div>
                  }
                </div>
              </div>
              }
            </div>
          </div>
          }
        </div>
      </div>
      } @else {
      <div class="text-center py-8">
        <lucide-icon
          [name]="carIcon"
          class="w-16 h-16 text-gray-400 mx-auto mb-4"
        />
        <p class="text-gray-500">
          No hay información de compatibilidad de vehículos disponible para este
          producto.
        </p>
      </div>
      }
    </div>
  `,
  styles: [],
})
export class VehicleGuideModalComponent {
  @Input() visible = false;
  @Input() vehicleGuideTree: GuiaProductoTreeElement[] = [];
  @Output() onClose = new EventEmitter<void>();

  readonly carIcon = CarIcon;
  readonly chevronDownIcon = ChevronDownIcon;
  readonly chevronRightIcon = ChevronRightIcon;

  handleClose() {
    this.visible = false;
    this.onClose.emit();
  }
}
